import React from 'react'
import { MWLButton } from 'react-web-white-label'
import './DpsButtonSummarisation.css'
const DpsButton = ({
  borderRadius = 8,
  buttonType = 'success',
  onClick,
  size = 'medium',
  label,
  buttonVariant = 'contained',
  isStartIconEnabled = true,
  startAdronIcon,
  isEndIconEnabled = true,
  endAdronIcon,
  disabled = false,
  className,
  orientation = 'horizontal',
  textTransform = 'none',
  count = 1,
}) => {
  return (
    <div className="StageTwoButtonComponentMainSection">
      <MWLButton
        borderRadius={borderRadius}
        color={buttonType}
        count={count}
        handleClick={onClick}
        size={size}
        text={label}
        variant={buttonVariant}
        isStartIconEnabled={isStartIconEnabled}
        startIcon={startAdronIcon}
        isEndIconEnabled={isEndIconEnabled}
        endIcon={endAdronIcon}
        disabled={disabled}
        className={`button btn--${
          className || buttonType
        } dPSButtonComponentSection`}
        orientation={orientation}
        textTransform={textTransform}
      />
    </div>
  )
}

export default DpsButton
